import { useEffect, useState } from "react";

const THEME_KEY = "kcg_theme";

export default function useTheme() {
  const [dark, setDark] = useState(() => {
    return localStorage.getItem(THEME_KEY) === "dark";
  });

  useEffect(() => {
    localStorage.setItem(THEME_KEY, dark ? "dark" : "light");
  }, [dark]);

  const toggle = () => setDark((d) => !d);

  return { dark, toggle };
}